export default class ParametroEliminarAutorizacion {
  constructor() {
    this.NumeroAutorizacion = "";
    this.TipoAutorizacion = 0;
    this.MotivoEliminacion = "";
  }

  NumeroAutorizacion: string;
  TipoAutorizacion: number;
  MotivoEliminacion: string;
}
